// extracted by mini-css-extract-plugin
export default {"header":"events_header__J1Z11","title":"events_title__x3riW"};